module.exports = __webpack_public_path__ + "img/step-1-plus.0c0cf019.svg";